import React, { useEffect, useRef, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {useDispatch, useSelector } from 'react-redux';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Swal from 'sweetalert2';
import FixedButton from '../FixedButton';
import MobileNavigation from '../MobileNavigation';
import { fatchQuotationAPI,DeleteQuotationAPI,EditQuotationAPI} from '../../redux/actionCreation';
import DatePicker from 'react-datepicker';
import { parseISO, format } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import { Link, useNavigate } from 'react-router-dom';
import Loader from '../Loader';
import Select from "react-select";
import { Country, State, City } from "country-state-city";
import QuoteEditPop from './QuoteEditPop'; // Naya component import karein


function QuotationList() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [loading_update, setLoading_update] = useState(false);
    useEffect(()=>{
        if(!localStorage.getItem('tokan')){
            navigate('/login');
        }
    }, []);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dispatch = useDispatch();
    let quotationtCounter = 0;
    const ref = useRef(null);
    const ref2 = useRef(null);
    const sidebarState = useSelector(state => state.sidebarReducres);
    const fetchQutReducers = useSelector(state => state.fetchQutReducers);
    const [selectedQuotId, setSelectedQuotId] = useState(null);
    const [filteredQuote, setFilteredQuote] = useState([]);
    const error_edit = useSelector(state => state.EditQuotationReducers.error?.edit_quotation_errors) ?? null;
    
     // Update Quotation Function
     const [formData, setFormData] = useState({  
            quotation_date: today,
            name: '',
            phone_number: '',
            service_name: '',
            c_gst:'',
            shift_start_date: '',
            shift_end_date: '',   
            customer_address: '',
            from_state: '',      // Added missing 'from_state'
            from_city: '',
            select_floor: '',    // Added missing 'select_floor'
            select_lift: '',     // Added missing 'select_lift'
            from_address: '',    // Added missing 'from_address'
            to_state: '',        // Added missing 'to_state'
            to_city: '',  // Added missing 'to_address'
            select_to_floor: '',    // Added missing 'select_floor'
            select_to_lift: '',     // Added missing 'select_lift'
            to_address: '', 
            shift_items: '', 
            enter_total_amt:'',
            transportation_charge: '',
            packing_charge: '',
            unpacking_charge: '',
            loading_charge: '',
            unloading_charge: '',
            insurance_charge: '',
            storage_charge: '',
            other_charge: '',
            total_charge: '',
            gst_hide_show:'Without GST Quotation',
            gst_type:'IGST',
            gst_per:'5',
            total_gst_charge:'',
            service_charge: '',
            Notes:'',
      });

        // Function to calculate total of specified fields
   const calculateTotal = () => {
    const {
      transportation_charge,
      packing_charge,
      unpacking_charge,
      loading_charge,
      unloading_charge,
      insurance_charge,
      storage_charge,
      other_charge
    } = formData;

    const total =
      parseFloat(transportation_charge) +
      parseFloat(packing_charge) +
      parseFloat(unpacking_charge) +
      parseFloat(loading_charge) +
      parseFloat(unloading_charge) +
      parseFloat(insurance_charge) +
      parseFloat(storage_charge) +
      parseFloat(other_charge);
    return total;
  };

    // Function to calculate SGST charge based on total and cgst_per
    const calculateSGSTCharge = (total, sgstPercentage) => {
        return (total * parseFloat(sgstPercentage)) / 100;
    };

    // Function to calculate CGST charge based on total and cgst_per
    const calculateCGSTCharge = (total, cgstPercentage) => {
        return (total * parseFloat(cgstPercentage)) / 100;
    };
    
    // Function to calculate IGST charge based on total and gst_per
    const calculateGSTCharge = (total, gstPercentage) => {
        return (total * parseFloat(gstPercentage)) / 100;
    };
  
    // useEffect to watch for changes in relevant fields and recalculate charges
    useEffect(() => {
        const total = calculateTotal();
        const gstCharge = calculateGSTCharge(total, formData.gst_per);
        const cgstCharge = calculateCGSTCharge(total, formData.cgst_per);
        const sgstCharge = calculateSGSTCharge(total, formData.sgst_per);
        // Update state with the calculated values
        setFormData((prevData) => ({
        ...prevData,
        total_charge:total.toFixed(2),
        gst_charge: gstCharge.toFixed(2), // Adjust decimal places as needed
        cgst_charge: cgstCharge.toFixed(2), // Adjust decimal places as needed
        sgst_charge: sgstCharge.toFixed(2), // Adjust decimal places as needed
        }));
    }, [
        formData.transportation_charge,
        formData.packing_charge,
        formData.unpacking_charge,
        formData.loading_charge,
        formData.unloading_charge,
        formData.insurance_charge,
        formData.storage_charge,
        formData.other_charge,
        formData.sgst_per,
        formData.cgst_per,
        formData.gst_per,
    ]);
  
    useEffect(() => {
        setFilteredQuote(fetchQutReducers.data);
  }, [fetchQutReducers.data]); 

  const [quotationNo, setQuotationNo] = useState("");
const [customerMobile, setCustomerMobile] = useState("");
  
  // Datewise Filter Code Start
const handleFormSubmit = (event) => {
    event.preventDefault();

    const newFilteredQuotation = fetchQutReducers.data.filter((item) => {

        // Date Filter
        const itemDate = new Date(item.quotation_date);

        const isWithinRange =
            (!formdate || itemDate >= formdate) &&
            (!todate || itemDate <= new Date(todate.getTime() + 86400000));

        // Quotation Number Filter
       const isQuotationMatch =
        !quotationNo ||
        item.quotation_number?.toString() === quotationNo.toString();

        // Mobile Number Filter
        const isMobileMatch =
            !customerMobile ||
            item.phone_number?.toString().includes(customerMobile);

        return (
            isWithinRange &&
            isQuotationMatch &&
            isMobileMatch
        );
    });

    setFilteredQuote(newFilteredQuotation);
};
// Datewise Filter Code End

const formatDate = (dateString) => {
    // Agar dateString khali hai, null hai ya "NA" hai, toh khali string return karo
    if (!dateString || dateString === "NA" || dateString === "" || dateString === "0000-00-00") {
        return ""; 
    }

    const date = new Date(dateString);

    // Check karo ki date valid hai ya nahi (RangeError se bachne ke liye)
    if (isNaN(date.getTime())) {
        return "";
    }

    try {
        const formattedDate = date.toISOString().split('T')[0];
        return formattedDate;
    } catch (error) {
        console.error("Format Date Error:", error);
        return "";
    }
};

    // Function to handle link click
    const UpdateQuotationClick = (QuoteId) => {
        setSelectedQuotId(QuoteId);
        const selectedQuote = fetchQutReducers.data.find(quotation => quotation.id === QuoteId);
    
        if (selectedQuote) {
            const formattedDate = formatDate(selectedQuote.quotation_date);
            const shift_start_date = formatDate(selectedQuote.shift_start_date);
            const shift_end_date = formatDate(selectedQuote.shift_end_date);
    
            const defaultTime = new Date();
            defaultTime.setHours(0, 0, 0, 0);
    
            setFormData({
                ...formData,
                quotation_date: formattedDate ? new Date(formattedDate + 'T00:00:00') : defaultTime,
                name: selectedQuote.name,
                phone_number: selectedQuote.phone_number,
                service_name: selectedQuote.service_name,
                c_gst:selectedQuote.c_gst,
                shift_start_date: shift_start_date ? new Date(shift_start_date + 'T00:00:00') : defaultTime,
                shift_end_date: shift_end_date ? new Date(shift_end_date + 'T00:00:00') : defaultTime,
                customer_address: selectedQuote.customer_address,
                from_state: selectedQuote.from_state,
                from_city: selectedQuote.from_city,
                select_floor: selectedQuote.select_floor,
                select_lift: selectedQuote.select_lift,
                from_address: selectedQuote.from_address,
                to_state: selectedQuote.to_state,
                to_city: selectedQuote.to_city,
                select_to_floor: selectedQuote.select_to_floor,
                select_to_lift: selectedQuote.select_to_lift,
                to_address: selectedQuote.to_address,
                shift_items: selectedQuote.shift_items,
                enter_total_amt: selectedQuote.enter_total_amt,
                transportation_charge: selectedQuote.transportation_charge,
                packing_charge: selectedQuote.packing_charge,
                unpacking_charge: selectedQuote.unpacking_charge,
                loading_charge: selectedQuote.loading_charge,
                unloading_charge: selectedQuote.unloading_charge,
                insurance_charge: selectedQuote.insurance_charge,
                service_charge: selectedQuote.service_charge,
                storage_charge: selectedQuote.storage_charge,
                other_charge: selectedQuote.other_charge,
                total_charge: selectedQuote.total_charge,
                gst_hide_show:selectedQuote.gst_hide_show,
                gst_type:selectedQuote.gst_type,
                gst_per:selectedQuote.gst_per,
                total_gst_charge:selectedQuote.total_gst_charge,
                Notes:selectedQuote.Notes,
            });
        } else {
            console.log("Quotation not found");
        }
    };
    
       // Delete Quotation Function
       const DeleteQuotation = async (QuoteId) => {
        // Show confirmation SweetAlert
        const result = await Swal.fire({
            title: `Are you sure Delete Quotation ?`,
            text: 'You won\'t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#673ab7',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        });
    
        if (result.isConfirmed) {
            try {
                await dispatch(DeleteQuotationAPI(QuoteId));
                dispatch(fatchQuotationAPI());
            } catch (error) {
            //   console.error('Error:', error);
            }
        } else {
            // User clicked "Cancel" or closed the SweetAlert
            console.log('Deletion cancelled.');
        }
    };


    const [formdate, setFormDate] = useState(null);
    const [todate, setToDate] = useState(null);
    const fromDate = (date) => {
        setFormDate(date);
      };
      const toDate = (date) => {
        setToDate(date);
      };
    

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await dispatch(fatchQuotationAPI());
                setLoading(false);
                // Process the result if needed
            } catch (error) {
                setLoading(false);
                console.log('Error fetching data:', error);
            }
        };
        fetchData(); // Call the async function
    }, []);

   // State for From Location
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [cities, setCities] = useState([]);

  // State for To Location
  const [selectedToState, setSelectedToState] = useState(null);
  const [selectedToCity, setSelectedToCity] = useState(null);
  const [toCities, setToCities] = useState([]);

  // Get all Indian states
  const states = State.getStatesOfCountry("IN").map((state) => ({
    value: state.isoCode,
    label: state.name,
  }));

  // Load Cities when Editing
  useEffect(() => {
    if (formData.from_state) {
      const stateObject = states.find((state) => state.value === formData.from_state);
      setSelectedState(stateObject);

      const filteredCities = City.getCitiesOfState("IN", formData.from_state).map((city) => ({
        value: city.name,
        label: city.name,
      }));

      setCities(filteredCities);

      if (formData.from_city) {
        const cityObject = filteredCities.find((city) => city.value === formData.from_city);
        setSelectedCity(cityObject);
      }
    }
  }, [formData.from_state, states]);

  useEffect(() => {
    if (formData.to_state) {
      const stateObject = states.find((state) => state.value === formData.to_state);
      setSelectedToState(stateObject);

      const filteredCities = City.getCitiesOfState("IN", formData.to_state).map((city) => ({
        value: city.name,
        label: city.name,
      }));

      setToCities(filteredCities);

      if (formData.to_city) {
        const cityObject = filteredCities.find((city) => city.value === formData.to_city);
        setSelectedToCity(cityObject);
      }
    }
  }, [formData.to_state, states]);

  // Handle "From" State Change
  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption);
    setSelectedCity(null);
    setFormData((prevData) => ({
      ...prevData,
      from_state: selectedOption.value,
      from_city: "",
    }));

    // Load new cities
    const filteredCities = City.getCitiesOfState("IN", selectedOption.value).map((city) => ({
      value: city.name,
      label: city.name,
    }));

    setCities(filteredCities);
  };

  // Handle "From" City Change
  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption);
    setFormData((prevData) => ({
      ...prevData,
      from_city: selectedOption.value,
    }));
  };

  // Handle "To" State Change
  const handleToStateChange = (selectedOption) => {
    setSelectedToState(selectedOption);
    setSelectedToCity(null);
    setFormData((prevData) => ({
      ...prevData,
      to_state: selectedOption.value,
      to_city: "",
    }));

    // Load new cities
    const filteredCities = City.getCitiesOfState("IN", selectedOption.value).map((city) => ({
      value: city.name,
      label: city.name,
    }));

    setToCities(filteredCities);
  };

  // Handle "To" City Change
  const handleToCityChange = (selectedOption) => {
    setSelectedToCity(selectedOption);
    setFormData((prevData) => ({
      ...prevData,
      to_city: selectedOption.value,
    }));
  };
  
  // const chargesConfig = [
  //   { key: 'transportation', label: 'Transportation Charge' },
  //   { key: 'packing', label: 'Packing Charge' },
  //   { key: 'unpacking', label: 'Unpacking Charge' },
  //   { key: 'loading', label: 'Loading Charge' },
  //   { key: 'unloading', label: 'Unloading Charge' },
  //   { key: 'insurance', label: 'Insurance Charge' },
  //   { key: 'storage', label: 'Storage Charge' },
  //   { key: 'other', label: 'Other Charge' },
  // ];
  
  // const initialIncludeState = {};
  // const initialFormData = {};
  
  // chargesConfig.forEach(item => {
  //   initialIncludeState[item.key] = true;
  //   initialFormData[`${item.key}_charge`] = '0'; // default Include
  // });
  
  // const [includeCharge, setIncludeCharge] = useState(initialIncludeState);
  // const [formDatainclude, setFormDatainclude] = useState(initialFormData);
  
  // // Checkbox toggle
  // const handleIncludeToggle = (key) => (e) => {
  //   const checked = e.target.checked;
  
  //   setIncludeCharge(prev => ({
  //     ...prev,
  //     [key]: checked,
  //   }));
  
  //   setFormDatainclude(prev => ({
  //     ...prev,
  //     [`${key}_charge`]: checked ? '0' : '', // unchecked -> blank
  //   }));
  // };
  
  // // Traportation etc charge input on change
  // const handleChangeCharge = (e) => {
  //   const { name, value } = e.target;
  
  //   // Allow only digits (0–9)
  //   if (!/^\d*$/.test(value)) {
  //     return;
  //   }
  
  //   const key = name.replace('_charge', '');
  
  //   if (!includeCharge[key]) {
  //     setFormDatainclude(prev => ({
  //       ...prev,
  //       [name]: value,
  //     }));
  //   }
  // };
  

  return (
    <>
        <FixedButton/>
        <div className={`main-content ${!sidebarState ? '' : 'navbar-ful'}`}>
            <div className='page-content'>
                <Container fluid>
                    <Row>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                            <h5 className='mb-1'>Search Quotation (Date, Quotation Number या Mobile Number से खोजें)</h5>
                        </Col>
                    </Row>

                    <Form onSubmit={handleFormSubmit}>
                        <Row className='search-list'>
                            <Col xs="6" sm="6" md="2" lg="2" xl="2" xxl="2" className="mt-2">
                                <div className="date-picker-container">
                                    <i className='calendar-icon fa fa-calendar'></i>
                                    <DatePicker
                                        selected={formdate}
                                        onChange={fromDate}
                                        dateFormat="dd/MM/yyyy"
                                        placeholderText="From Date"
                                        className='form-control'
                                    />
                                </div>
                            </Col>

                            <Col xs="6" sm="6" md="2" lg="2" xl="2" xxl="2" className="mt-2">
                                <div className="date-picker-container">
                                    <i className='calendar-icon fa fa-calendar'></i>
                                    <DatePicker
                                        selected={todate}
                                        onChange={toDate}
                                        dateFormat="dd/MM/yyyy"
                                        placeholderText="To Date"
                                        className='form-control'
                                    />
                                </div>
                            </Col>

                            <Col xs="6" sm="6" md="2" lg="2" xl="2" xxl="2" className="mt-2">
                                <Form.Group>
                                    <Form.Control
                                        type="text"
                                        placeholder="Quotation No"
                                        value={quotationNo}
                                        onChange={(e) => setQuotationNo(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>

                            <Col xs="6" sm="6" md="2" lg="2" xl="2" xxl="2" className="mt-2">
                                <Form.Group>
                                    <Form.Control
                                        type="text"
                                        placeholder="Customer Mobile"
                                        value={customerMobile}
                                        onChange={(e) => setCustomerMobile(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>

                            {/* <Col xs="6" sm="6" md="2" lg="3" xl="3" xxl="3" className="mt-2">
                                <Form.Group className="" onChange={cut_num} controlId="formGroupEmail">
                                    <Form.Control type="number" min={0} placeholder="Customer Number" />
                                </Form.Group>
                            </Col> */}

                            {/* <Col xs="6" sm="6" md="2" lg="3" xl="3" xxl="3" className="mt-2">
                                <Form.Group className="" controlId="formGroupEmail">
                                    <Form.Control type="text" onChange={cut_name} placeholder="Customer Name" />
                                </Form.Group>
                            </Col> */}
                            
                            <Col xs="6" sm="6" md="2" lg="2" xl="2" xxl="2" className="mt-2">
                                <Button variant="primary" type="submit" className="">
                                    Submit
                                </Button>
                            </Col>
                        </Row>
                    </Form>

                    <Row>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className='mt-4'>
                            <h5 className='mb-3'>QuotationList List</h5>
                        </Col>
                    </Row>
                    <div className='text-center'>
                        {loading && <Loader />}
                    </div>

                    {!loading && (
                    <Row>
                        {filteredQuote && Array.isArray(filteredQuote) && filteredQuote.length > 0 ? (
                        [...filteredQuote].reverse().map(item => (
                        <Col key={item.id} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6">
                            <div className="dash-count bill_box das3">
                                <div className="dash-counts">
                                    <h4 className="text-dark c_name">{item.name}</h4>
                                    <h5 className="text-dark text-green">Quotation #{item.quotation_number}</h5>
                                    {item.quotation_date && !isNaN(Date.parse(item.quotation_date)) && (
                                        <h5 className="text-dark">
                                            {format(parseISO(item.quotation_date), 'dd-MM-yyyy')}
                                        </h5>
                                    )}
                                </div>

                                <div className="dash-imgs">
                                    <i className="text-dark invoice_i fa fa-indian-rupee-sign mr-0"></i>
                                    <span className="amount text-dark">{item.total_amount}</span>
                                        <p>
                                            <Link to={`/quotationedit/${item.id}`}>
                                                <i className='view_invoice_i pr-3 fa fa-eye'></i>
                                            </Link>

                                            <Link onClick={() => UpdateQuotationClick(item.id)}  type="button" data-bs-toggle="offcanvas" data-bs-target="#staticBackdropQuote" aria-controls="staticBackdropQuote">
                                                <i className='view_invoice_i pr-3 fa fa-edit'></i>
                                            </Link>

                                            <Link to="#" onClick={() => DeleteQuotation(item.id)}>
                                                <i className='delet_invoice_i pr-3 fa fa-trash'></i>
                                            </Link>
                                        </p>
                                </div>
                            </div>
                            </Col>
                        ))
                        ) : (
                        <div className='text-center not_data mt-3'>
                            <i className="fa-solid fa-triangle-exclamation"></i>
                            <p>No data available</p>
                        </div>
                        )}
                    </Row>
                    )}
                </Container>
            </div>
            <MobileNavigation/>

           {/* Popup Component - All Logic is inside this */}
            <QuoteEditPop QuoteId={selectedQuotId} allData={fetchQutReducers.data} />
        </div>
    </>
  )
}

export default QuotationList
